export default {
    page_title: "Kevi | Users",
    title: "Users",
    subtitle: "Who can access Kevi Marketing.",
    add: "Add user",
    search: "Search by name or email",
    columns: {
        user: "User",
        contact: "Contact",
        phone: "Phone",
        twofa: "2FA",
        last_access: "Last access",
        actions: "Actions",
    },
    twofa_on: "Enabled",
    twofa_off: "Disabled",
    no_email: "No email",
    no_phone: "No phone",
    no_contact: "No email and phone.",
    unverified: "Not verified",
    unused: "Not in use",
    tooltip_mkt: "Kevi Marketing. This person can access this product.",
    tooltip_chat: "Kevi Chat. This person also has access to Kevi Chat.",
    tooltip_email_pending: "Email not verified. Until it is, it cannot be used to reset the password.",
    tooltip_phone_pending: "Phone not verified. Until it is, it cannot be used to reset the password.",
    tooltip_no_contact: "No email and no phone. This person cannot reset their own password.",
    today: "Today {0}",
    yesterday: "Yesterday {0}",
    never: "Never signed in",
    empty: "No users found",
    empty_hint: "Add the people who will access Kevi Marketing.",
    empty_filters: "Nothing matches these filters.",
    loading: "Loading users...",
    clear_filters: "Clear filters",
    reload: "Reload",
    load_error: "Users could not be loaded.",
    load_error_hint: "The connection failed. Try again in a moment.",
    filters: {
        products: "Linked apps",
        twofa: "Two-factor authentication",
        contacts: "Contacts",
        marketing: "Kevi Marketing",
        chat: "Kevi Chat",
        email_verified: "Verified email",
        email_pending: "Pending email",
        no_email: "No email",
        phone_verified: "Verified phone",
        phone_pending: "Pending phone",
        no_phone: "No phone",
    },
    menu: {
        edit_profile: "Edit profile",
        edit_permissions: "Edit permissions",
        set_password: "Set a new password",
        deactivate: "Deactivate user",
    },
    password_modal: {
        title: "Enter your administrator password",
        subtitle: "For security, actions that affect other users ask for your password.",
        label: "Current password",
        close: "Close",
        continue: "Continue",
        submitting: "Validating...",
        wrong: "The administrator password does not match.",
        failed: "Could not finish. Try again.",
        too_many: "Too many password attempts. Wait a few minutes and try again.",
    },
    create: {
        title: "Create user",
        step_user: "User",
        step_permissions: "Permissions",
        name: "Full name",
        searching: "Looking for similar users...",
        found: "{0} similar users found",
        found_one: "1 similar user found",
        none: "No users found",
        none_hint: "Create a new user with this name.",
        failed_title: "Search failed",
        failed: "We could not check for similar users. You can still create a new one and review later.",
        create_named: "Create user {0}",
        existing: "Existing users",
        view_profile: "View profile",
        link: "Link user",
        recover: "Recover user",
        import: "Import user",
        linking: "Linking user · Kevi Chat > Kevi Marketing",
        photo_add: "Add photo",
        photo_change: "Change photo",
        photo_edit: "Edit photo",
        username: "Username",
        username_placeholder: "Enter a valid username",
        password: "Password",
        repeat: "Repeat password",
        email: "Email",
        email_placeholder: "Enter an email for this user",
        phone: "Phone",
        phone_placeholder: "Enter a phone for this user",
        product_marketing: "Kevi Marketing access",
        product_chat: "Kevi Chat access",
        yes: "Yes",
        no: "No",
        back: "Back",
        next: "Next",
        need_name: "Enter the full name (min. 3 characters).",
        need_username: "Enter a valid username (min. 3 characters).",
        need_password: "Set a password with at least 8 characters.",
        need_password_match: "Password and confirmation must match.",
        submit: "Create user",
        success: "User created successfully!",
        linked: "User linked successfully!",
        linked_note: "The same login and password work for Kevi MKT and Kevi Chat.",
        no_contact_title: "Create without email or phone?",
        no_contact_body: "Without a contact, this user will not be able to reset their own password.",
        continue_anyway: "Continue anyway",
        another: "Create another",
        done: "Finish",
        taken: "This value is already used by {0}. Go back to search to link or recover them.",
        permissions_title: "Kevi Marketing permissions",
        permissions_subtitle: "Control access to billing, user management, and this product's modules.",
        billing: "Billing",
        billing_help: "Accesses account, invoices, plans, and payments.",
        users: "Users",
        users_help: "Manages users and other people's permissions.",
        modules: "Modules",
        linking_label: "Linking user",
        importing_label: "Importing user",
        recovering_label: "Recovering deactivated user",
        back_to_search: "Back to search",
        reason_empty: "is required",
        reason_small: "is too short",
        reason_invalid: "is invalid",
        reason_taken: "is already in use",
    },
    edit: {
        title: "Editing user",
        load_error_title: "This user could not be loaded",
        load_error_body: "The profile may have been removed, or the connection failed. Try again or go back to the list.",
        permissions: "Edit permissions",
        password: "Editing password",
        back: "Back",
        save: "Save",
        apply: "Apply",
        change_password: "Change password",
        new_password: "Enter the new password",
        repeat: "Repeat the new password",
        show: "Show password",
        hide: "Hide password",
        contact_title: "You changed an active user's details",
        contact_body: "The user will need to confirm the contact details after this change.",
        contact_back: "Back",
        contact_continue: "Continue anyway",
        sessions_title: "You changed an active user's details",
        sessions_body: "If you sign them out, open sessions end and they must sign in with the new password.",
        keep_sessions: "Save without signing out",
        end_sessions: "Sign out of all devices",
        toast_kept: "Password changed. Open sessions were kept.",
        toast_ended: "Password changed. Devices were signed out.",
        saved: "Changes saved.",
        taken_field: "This {0} is already used by another user.",
    },
    deactivate: {
        title: "Deactivate user?",
        body: "The user loses access to Kevi Marketing immediately and no longer counts on the plan.",
        chat: "Access to Kevi Chat continues. To end it, deactivate them there too.",
        cancel: "Cancel",
        confirm: "Deactivate user",
        done: "User deactivated",
        self: "You cannot deactivate your own account.",
        protected: "This user is protected and cannot be changed here.",
        failed: "Could not deactivate. Try again.",
        last_admin: "The account needs at least one user with the Users permission.",
        self_permission: "You cannot remove your own Users permission.",
    },
    profile: {
        title: "My profile",
        personal: "Personal details",
        personal_help: "How your name appears to the team and in customer conversations.",
        change: "Change",
        security: "Security",
        security_help: "How you recover your account and protect your access.",
        warning_title: "Add more protection to your account",
        warning_body: "Complete the pending items below. They let you recover access on your own and make the account safer.",
        recovery: "Recovery methods",
        recovery_help: "We send the password reset code to the contacts verified here.",
        verified: "Verified",
        unverified: "Not verified",
        inactive: "Inactive",
        active: "Active",
        add_email: "Add email",
        add_phone: "Add phone",
        change_email: "Change email",
        change_email_button: "Change",
        verify: "Verify",
        no_phone: "No phone added",
        twofa: "Two-factor authentication",
        twofa_help: "After the password, we ask for a code from your authenticator app.\nIt protects the account even if the password leaks.",
        enable: "Enable",
        disable: "Disable",
        password: "Password",
        password_changed: "Changed on {0}.",
        password_unknown: "Change your password whenever you want.",
        change_password: "Change password",
        password_rule: "Use at least 8 characters.",
        note: "We ask for your current password whenever you change something on this screen.",
        logout_title: "Sign out",
        logout_help: "You will be signed out of this device only.",
        logout: "Sign out",
        name_title: "Change name",
        current_password: "Current password",
        cancel: "Cancel",
        send_code: "Send code",
        your_email: "Your email",
        confirm_email: "Confirm your email",
        your_phone: "Your phone",
        confirm_phone: "Confirm your phone",
        add_email_help: "We send a code to confirm the email is yours. It will be used to reset your password.",
        add_phone_help: "We send an SMS code to confirm the phone is yours. It will be used to reset your password.",
        change_email_help: "The new email only takes effect after it is verified. Until then, the current one is still used for recovery.",
        change_phone_help: "The new phone only takes effect after it is verified. Until then, the current one is still used for recovery.",
        code_title: "Enter the code",
        code_help: "We sent a 6-digit code to {0}.",
        code_sms: "We sent a 6-digit SMS code to {0}.",
        resend_in: "Didn't get it? Resend in {0}",
        resend: "Resend code",
        confirm: "Confirm",
        invalid_code: "Invalid or expired code. Request a new code.",
        email_toast: "Email verified",
        email_toast_body: "You can now reset your password by email.",
        email_changed_toast: "Email changed",
        email_changed_toast_body: "You can now reset your password with this email.",
        phone_toast: "Phone verified",
        phone_toast_body: "You can now reset your password by phone.",
        password_title: "Change password",
        new_password: "New password",
        repeat_password: "Repeat the new password",
        change_password_button: "Change password",
        password_toast: "Password changed.",
        confirm_password_title: "Confirm your password",
        confirm_password_help: "To turn on two-factor authentication, confirm it is you.",
        continue: "Continue",
        qr_title: "Scan the QR code",
        qr_step: "Step 1 of 3",
        qr_help: "Open your authenticator app (Google Authenticator, Authy, 1Password) and scan the code.",
        manual_key: "Can't scan it? Use the key below in your app.",
        copy: "Copy",
        copied: "Copied",
        code_step: "Step 2 of 3",
        app_code: "Enter the app code",
        app_code_help: "Enter the 6 digits shown in your authenticator app.",
        app_code_hint: "The code changes every 30 seconds.",
        app_code_error: "Invalid or expired code. Try again.",
        activate: "Enable",
        codes_step: "Step 3 of 3",
        codes_title: "Two-factor authentication is on",
        codes_help: "Save your recovery codes. Each code works once and is the only way in if you lose the app.",
        copy_codes: "Copy codes",
        download: "Download .txt",
        saved_codes: "I saved my codes",
        disable_title: "Turn off two-factor authentication?",
        disable_body: "Confirm your password to turn it off.",
        disable_button: "Turn off 2FA",
        disabled_title: "Two-factor authentication is off",
        disabled_body: "Only the password protects your account now. You can turn two-factor authentication back on whenever you want.",
        enable_again: "Turn 2FA on again",
        close: "Close",
        disabled_toast: "2FA turned off!",
        disabled_toast_body: "We recommend turning it back on as soon as you can.",
        wrong_password: "Incorrect password.",
        mismatch: "The password and the confirmation do not match. Go back and check both fields.",
        contact_mismatch: "The confirmation fields do not match. Check them and try again.",
        invalid_phone: "Invalid phone. Use area code + number.",
        send_failed: "Could not send the code. Try again.",
        too_many: "Too many attempts. Wait a few minutes and try again.",
        photo_saved: "Photo updated.",
        photo_failed: "Could not update the photo. Try again.",
        taken: "This contact is already in use.",
        disable_warning: "The account will rely on the password only. Recovery codes will stop working.",
        change_phone: "Change phone",
        verify_email: "Confirm email",
        verify_phone: "Confirm phone",
        verify_email_help: "We'll send a code to the email on file. It will be used to reset your password.",
        verify_phone_help: "We'll text a code to the phone on file. It will be used to reset your password.",
        phone_placeholder: "(99) 9 9999-9999",
        phone_changed_toast: "Phone changed",
        phone_changed_toast_body: "You can now reset your password with this new phone.",
        name_help: "This is how your name appears to your team and in conversations with customers.",
        name_required: "Enter your full name.",
        name_toast: "Full name changed.",
        save: "Save",
        too_many_attempts: "Too many password attempts. Wait a few minutes and try again.",
        generic_error: "Could not complete. Try again.",
        invalid_email: "Invalid email. Check it and try again.",
        missing_contact: "There is no contact on file to confirm.",
        code_expired: "The code has expired. Request a new code.",
        code_too_many: "Too many attempts with this code. Request a new code.",
        twofa_restart: "Time to enable is over. Confirm your password again.",
        twofa_too_many: "Too many attempts with the code. Confirm your password and start again.",
        qr_alt: "QR code for the authenticator app",
    },
    prompt: {
        no_contact_title: "Your account cannot be recovered",
        no_contact_body: "You still do not have a verified email or phone. If you forget your password, only an administrator at your company can reset access for you.",
        email_title: "Confirm your email",
        email_body: "The email {0} was registered by your company, but it has not been confirmed. Until you confirm it, only an administrator can reset your password.",
        phone_title: "Confirm your phone",
        phone_body: "The phone {0} was registered by your company, but it has not been confirmed. Until you confirm it, only an administrator can reset your password.",
        add_phone: "Add phone",
        add_email: "Add email",
        other_email: "Use another email",
        confirm_email: "Confirm email",
        other_phone: "Use another phone",
        confirm_phone: "Confirm phone",
        later: "Not now",
    },
};
